import BasicRoute from "components/routes/BasicRoute"
import Controle from "entity/Controle"

export default function RoutesMenusControle() {

    return (
        <>
            <BasicRoute
                perfilAuth='r9jrEQXznNgjrZTGCfch' //admin
                uid="controle"
                route="controle"
                menuProps={{
                    text: "Controle",
                    sequence: "199999",
                    iconName: 'SupervisorAccount',
                }}

                element={<Controle />}
            />
        </>
    );
}
